var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import EmptyState from "@atlaskit/empty-state";
import { Spinner } from "@atlassiansox/microscopekit";
import illustration from "./illustration.svg";
export var ExerciseBeingPrepared = function () { return (React.createElement(EmptyState, { header: "Preparing Wargame Exercise", imageUrl: illustration, maxImageHeight: 400, maxImageWidth: 400, description: React.createElement(React.Fragment, null,
        "We\u2019re setting everything up for you. Please check back in a few seconds!",
        React.createElement(SpinnerContainer, null,
            React.createElement(Spinner, { size: "medium" }))) })); };
var SpinnerContainer = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  left: 2rem;\n"], ["\n  position: relative;\n  left: 2rem;\n"])));
var templateObject_1;
